import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Axios from "axios";

import { useStyles } from "../../../../../Components/CSS/FormStyle.css";
import AdminHeader from "../../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { url } from "../../../../../Config/Config";
import ItemsForm from "../ItemsForm/ItemsForm";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import FormLoader from "../../../../../Components/FormLoader/FormLoader";
import PageTitle from "../../../../../Components/PageTitle/PageTitle";
import CustomBreadCrumbs from "../../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class ViewItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      column: [
        { name: "S.N." },
        { name: "Item Name" },
        { name: "Quantity" },
        { name: "Rate (Per pcs)" },
        { name: "Total" },
        { name: "Purchase From" },
        { name: "Purchase Date" },
        { name: "Actions" },
      ],
      categoryName: "",
      itemStatus: false,
      itemDetails: {},
      items: [],
      categoryId: "",
      loading: false,
      categoryError: "",
    };
  }

  handleCategoryChange = (e) => {
    this.setState({
      categoryName: e.target.value,
    });
  };

  checkCategoryError = (categoryName) => {
    let categoryError = categoryName ? categoryName : "";
    if (categoryError) {
      this.setState({ categoryError });
      return true;
    } else {
      this.setState({ categoryError: "" });
      return false;
    }
  };

  handleCategorySubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkCategoryError();
    if (errorStatus === false) {
      try {
        this.setState({ loading: true });
        const response = await Axios.post(
          `${url}/api/item-categories`,
          {
            categoryName: this.state.categoryName,
          },
          {
            headers: { Authorization: `Bearer ${this.props.adminToken}` },
          }
        );
        if (response.data.itemCategoryId) {
          this.getCategoryDetails(response.data.itemCategoryId);
          this.setState({
            categoryId: response.data.itemCategoryId,
            itemStatus: true,
            loading: false,
          });
        }
      } catch (error) {
        this.setState({ loading: false });
        if (
          error.response.data.message ===
          "Item category of given name already exists"
        ) {
          console.clear();
          this.checkCategoryError(error.response.data.message);
        }
        if (
          error.response.data === "jwt expired" &&
          error.response.status === 401
        ) {
          console.clear();
          let refreshToken = { refreshToken: this.props.refreshToken };
          this.props.getAdminRefreshToken(refreshToken, this.props.role);
          this.handleCategorySubmit(e);
        }
      }
    }
  };

  checkError = () => {
    let itemsError = "";
    if (this.state.data.items.length === 0) {
      itemsError = "No any items are entered. Please enter at least one";
    }
    if (itemsError) {
      this.setState({
        itemsError,
      });
      return true;
    } else {
      this.setState({
        itemsError: "",
      });
      return false;
    }
  };

  getCategoryDetails = async (categoryId) => {
    try {
      const response = await Axios.get(
        `${url}/api/item-categories/${categoryId}`,
        {
          headers: { Authorization: `Bearer ${this.props.adminToken}` },
        }
      );
      if (response.data.itemCategory) {
        this.setState({
          itemDetails: response.data.itemCategory,
          items: response.data.itemCategory.items,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getCategoryDetails(categoryId);
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle title="Add Inventory and Categories" />
          <form onSubmit={this.handleCategorySubmit}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <TextField
                name="categoryName"
                type="text"
                required
                fullWidth
                label="Category Name"
                variant="outlined"
                margin="normal"
                error={this.state.categoryError ? true : false}
                helperText={this.state.categoryError}
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.categoryName}
                onChange={this.handleCategoryChange}
              />
              <div style={{ display: "flex", alignItems: "center" }}>
                <Button
                  type="submit"
                  variant="outlined"
                  className={classes.buttonStyle}
                >
                  Add Category
                </Button>
                {this.state.loading && <FormLoader />}
              </div>
            </div>
          </form>
          {this.state.itemStatus && (
            <ItemsForm
              column={this.state.column}
              categoryId={this.state.categoryId}
              items={this.state.items}
              getCategoryDetails={this.getCategoryDetails}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ViewItems)));
